<div
    class="cmps-cdk-bg-color-white cmps-cdk-d-block cmps-cdk-p-0dot5 cmps-cdk-pos-absolute cmps-cdk-pos-bottom-0 cmps-cdk-pos-right-0 cmps-cdk-text-center"
    [class.cmps-cdk-d-block]="_isVisible"
    [class.cmps-cdk-d-none]="!_isVisible"
    [style.z-index]="999999"
    aria-hidden="true"
    (document:keydown)="_onDocumentKeydown($event)"
    #containerRef
>
    <div class="cmps-cdk-d-flex cmps-cdk-flex-column">
        <div class="cmps-cdk-d-flex cmps-cdk-flex-row">
            <div>
                <button
                    type="button"
                    class="cmps-cdk-bg-color-transparent cmps-cdk-border-width-0p cmps-cdk-cursor-pointer cmps-cdk-px-0dot5 cmps-cdk-py-0dot25"
                    (click)="_onMoveClick(containerRef, true)"
                >
                    L
                </button>
            </div>
            <div class="cmps-cdk-flex-grow-1">debug</div>
            <div>
                <button
                    class="cmps-cdk-bg-color-transparent cmps-cdk-border-width-0p cmps-cdk-cursor-pointer cmps-cdk-px-0dot5 cmps-cdk-py-0dot25"
                    (click)="_onMoveClick(containerRef, false)"
                >
                    R
                </button>
            </div>
        </div>
        <div>
            <button
                class="cmps-cdk-bg-color-transparent cmps-cdk-border-width-0p cmps-cdk-cursor-pointer cmps-cdk-px-0 cmps-cdk-py-0dot25 cmps-cdk-w-100pct"
                (click)="_onInvokeReAuthClick()"
            >
                invoke re-auth
            </button>
        </div>
        <div>
            <button
                class="cmps-cdk-bg-color-transparent cmps-cdk-border-width-0p cmps-cdk-cursor-pointer cmps-cdk-px-0 cmps-cdk-py-0dot25 cmps-cdk-w-100pct"
                (click)="_onInvokeTimeoutClick()"
            >
                invoke timeout
            </button>
        </div>
        <div>
            <button
                class="cmps-cdk-bg-color-transparent cmps-cdk-border-width-0p cmps-cdk-cursor-pointer cmps-cdk-px-0 cmps-cdk-py-0dot25 cmps-cdk-w-100pct"
                (click)="_onInvokeAuthLostClick()"
            >
                invoke auth lost
            </button>
        </div>
        <div>
            <button
                class="cmps-cdk-bg-color-transparent cmps-cdk-border-width-0p cmps-cdk-cursor-pointer cmps-cdk-px-0 cmps-cdk-py-0dot25 cmps-cdk-w-100pct"
                (click)="_onToggleSsoSimulationClick()"
            >
                toggle sso simulation ({{
                    !_hasSaml2AuthMethod ? 'off' : 'on'
                }})
            </button>
        </div>
        <div class="cmps-cdk-text-center">
            {{ _build || 'none' }}
        </div>
    </div>
</div>
